import React, { Component } from 'react';
// import { useHistory } from 'react-router-dom';
import axios from 'axios'
import DOMPurify from 'dompurify';
import {Box, Button, TextField, Heading,Dropdown,Toast} from 'monday-ui-react-core';
import {getParticularBoardId,getAssetValueProcess,mondayContextProcess,statusChangeToSomething,dateConvertion,returnAllocationProcess,
    successOrErrorMessageNotice,readParticularBoard,mondatLocationProcess} from '../monday-api/ApiHandling';
    import env from "react-dotenv";
    let baseUrl = process.env.REACT_APP_SERVER_URL;
    
export default class ReturnForm extends Component {
    constructor(props){
        super(props)
        this.state={
            assetName:this.props.assetName,
            description:this.props.description,
            status:this.props.status,
            requestId:'',
            managerId:'',
            currentEmployeeId:'',
            currentEmployeeName:'',
            assetId:this.props.assetId,
            returnComment:'',
            isLoading:false,
            redirectUrl:'',
            messageSuccessOrFailure:'',
            isToast:false,
            requestsData:this.props.requests
			
        }
    }

    async componentDidMount() {
        // Retrieve a value from local storage
        if (localStorage.getItem("managerId")) {
            this.setState({
                managerId: localStorage.getItem("managerId")
            })
        }
    }


    // returnProcess=async()=>{
    //     const {assetId}=this.state;
    //     const boardWorkspaceId=1922534;
    //     const getAllocationBoardId=await getParticularBoardId(boardWorkspaceId,'Allocation History');
    //     const readAllocationBoardResponse=await readParticularBoard(getAllocationBoardId);
    //     for(let getItemValues of readAllocationBoardResponse){
    //         const getColumnValuesOfAllocation=getItemValues.column_values;
    //         for(let getColumnValue of getColumnValuesOfAllocation){
    //           if(getColumnValue.id==="text80"){
    //             if(getColumnValue.text===assetId){
    //                 getItemValues.column_values.map((value,index)=>{
    //                     if(value.id==="text"){
    //                         this.setState({
    //                             currentEmployeeId:`${value.text}`
    //                         })
    //                     }
    //                     if(value.id==="text79"){
    //                         this.setState({
    //                             currentEmployeeName:`${value.text}`
    //                         })
    //                     }
    //                 })

    //             }
    //           }
    //         }
    //     }
    // }

    onChangeRequestId=(eventRequestId)=>{
        this.setState({
            requestId:eventRequestId
        })
    }

    handleRequestId = (e)=>{
        this.setState({
            requestId: e.value
        })
    }

    onChangeManagerId=(eventManagerId)=>{
        this.setState({
            managerId:eventManagerId
        })
    }

    onChangeReturnComments=(eventComments)=>{
        this.setState({
            returnComment:eventComments.value
        })
    }

    onClickReturn=async()=>{
        this.setState({
            isLoading: true
        })
        const succesMessage="Asset returned was successfully";
        const errorMessage="Failed to Return";
        const managerError="Invalid manager Id";
        const { assetName, description, status, requestId, managerId, assetId, returnComment } = this.state;
        const returnComments = DOMPurify.sanitize(returnComment);
        if(assetName&&description&&status&&requestId&&managerId&&returnComment){
            let formData = {
                "managerId": managerId,
                "requestId": requestId,
                "comment": returnComments,
                "type": "Physical",
                "requestType": status==="Active"?"request":"return",
                "assetId": assetId
            }
            await axios.post(`${baseUrl}/asset-request`, formData)
            .then((res)=>{
                this.setState({
                    isLoading: false,
                    isToast: true,
                    messageSuccessOrFailure:succesMessage
                })
                window.location.replace(res.data);
            })
            .catch((err)=>{
                if(err.response.status===401||err.response.status===404){
                    this.setState({
                        isLoading:false,
                        isToast:true,
                        messageSuccessOrFailure:managerError
                    })
                }
                else{
                    this.setState({
                        isLoading:false,
                        isToast:true,
                        messageSuccessOrFailure:errorMessage
                    })
                }
            })
        }
        else{
            this.setState({
                isLoading: true
            })
            const errorMessage="Please fill all the fields";
            this.setState({
                isLoading:false,
                isToast:true,
                messageSuccessOrFailure:errorMessage,
            })
        }
        
        
    }

  render() {
    const {assetName,description,status,requestId,managerId,returnComment,currentEmployeeId,currentEmployeeName,messageSuccessOrFailure,isToast}=this.state;
    let currentEmployee;
    if(currentEmployeeId!==""&&currentEmployeeName!==""){
        currentEmployee=`${currentEmployeeName}(${currentEmployeeId})`;
    }
    else{
        currentEmployee='';
    }

    const damagedComments=[
        {
            label:'Asset is in good condition',
            value:'Asset is in good condition'
        },
        {
            label:'Asset has minor scratches and dents',
            value:'Asset has minor scratches and dents'
        },
        {
            label:'Asset is poorly damaged',
            value:'Asset is poorly damaged'
        }
    ]
    

    return (
      <div className='responsive-return'>
        {
            isToast?
            <div>
                {
                    messageSuccessOrFailure==="Asset returned was successfully"?
                    <div>
                        <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.POSITIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                    </div>:
                    <div>
                        <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                    </div>
                }
                {
                    messageSuccessOrFailure === "Please fill all the fields" ?
                        <div>
                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                        </div> :null
                }
                {
                    messageSuccessOrFailure === "Invalid manager Id" ?
                        <div>
                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                        </div> :null
                }
            </div>:null
        }
        <br/>
        <br/>
        <br/>
        <br/>
        <Box className='box' border={Box.borders.DEFAULT} paddingX={Box.paddingXs.MEDIUM}  paddingY={Box.paddingYs.MEDIUM} rounded={Box.roundeds.MEDIUM}>
            <Heading value='Return Form' type={Heading.types.h2} style={{textAlign:"center"}}/>
            {/* <Heading customColor="red" size="xxs" type="h5" value="Note: If you have Request ID then enter the Request ID field otherwise leave it"/> */}
            <TextField
                title="Name"
                value={assetName}
                wrapperClassName="monday-storybook-text-field_size"
                requiredAsterisk={true}
                readonly
            />
            <br/>
            <TextField
                title="Description"
                value={description}
                wrapperClassName="monday-storybook-text-field_size"
                requiredAsterisk={true}
                readonly
            />
            <br/>
            <TextField
                title="Status"
                value={status}
                wrapperClassName="monday-storybook-text-field_size"
                requiredAsterisk={true}
                readonly
            />

            <br/>
            <div style={{padding:'8px',paddingLeft:"0px"}}>
                <label>Request Id<span className='asterisk'>*</span></label>
            </div>
             <Dropdown placeholder="Choose requestt Id" options={this.state.requestsData} className="dropdown-stories-styles_big-spacing" onChange={(e)=>this.handleRequestId(e)} />
            <br/>
            <TextField
                onChange={(eventManagerId)=>this.onChangeManagerId(eventManagerId)}
                value={managerId}
                type={TextField.types.PASSWORD}
                title="Asset Manager ID"
                requiredAsterisk={true}
                wrapperClassName="monday-storybook-text-field_size"
            />
            <br/>
            <div style={{padding:'8px'}}>
                <label>Return Comment<span className='asterisk'>*</span></label>
            </div>
            <Dropdown placeholder="Choose return comment here" options={damagedComments} className="dropdown-stories-styles_big-spacing" onChange={(eventReturnComment)=>this.onChangeReturnComments(eventReturnComment)} />
            <br/>
            <Button loading={this.state.isLoading} style={{float:'right'}} onClick={this.onClickReturn}>Return</Button>
        </Box>
      </div>
    )
  }
}
